<template>
	<div style="margin-top:20px;">
		<div class="info-wrap">
			<table cellspacing="1" width="100%" class="order-info">
				<tr>
					<td>定金单编码：{{depositBillMainVO.billCode}}</td>
				</tr>
				<tr>
					<td>苗场：{{depositBillMainVO.seedFarmName}}</td>
				</tr>
				<tr>
					<td>交货日期：{{depositBillMainVO.sendProductDate}}</td>
				</tr>
				<tr>
					<td>周次：{{depositBillMainVO.weekSeq+'周（'+depositBillMainVO.weekBeginDate+'~'+depositBillMainVO.weekEndDate+'）'}}
					</td>
				</tr>
				<!-- <tr>
                	<td>待付金额：{{depositBillMainVO.remainingSum}}元 </td>
                </tr> -->
			</table>
		</div>

		<div class="dataTable">
			<b-table id="orderDetail-table" :fields="orderDetail.fields" :items="orderDetail.items" small bordered hover
				:busy="orderDetail.isTableBusy" caption-top>
				<template v-slot:cell(index)="row">
					<template v-if="row.item.productCode==''||row.item.productCode=='定金收取(%)'">
						<span></span>
					</template>
					<template v-else>
						{{ row.index + 1 }}
					</template>
				</template>
				<template v-slot:cell(orderQuantity)="row">
					<template v-if="row.item.depositBillDetailUuid||row.item.unitName=='数量合计'">
						<span>{{ parseFloat(row.item.orderQuantity) }}</span>
					</template>
					<template v-else>
						<span>{{ row.item.orderQuantity }}</span>
					</template>
				</template>
					<template v-slot:cell(totalMoney)="row">
					<template v-if="row.item.preSalePlanPrice=='总额'||row.item.productName=='折扣'">
						<span>{{ parseFloat(row.item.totalMoney.toFixed(2)) }}</span>
					</template>
					<template v-else>
						<span>{{ row.item.totalMoney }}</span>
					</template>
				</template>
				<template slot="table-caption">
					<span style="font-weight: bold;">定单详细信息:{{depositBillMainVO.billCode}}</span>
					<span style="color:red;">请于{{depositBillMainVO.sendProductDateBefore}}前打款支付余额。（交货日三天前）</span>
				</template>
				<div slot="table-busy" class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>加载中...</strong>
				</div>
			</b-table>
			<p v-if="depositBillMainVO.customerMsg != null">客户备注:<strong>{{depositBillMainVO.customerMsg}}</strong></p>
		</div>
	</div>
</template>

<script>
	import api from '@/api/api';
	import {
		formatDateTimeString,
		numberToFixed
	} from '@/libs/utils';
	import search from '@/libs/search';
	import "@/style/global.css";
	export default {
		name: 'BookingOrderDetail',
		components: {
		},
		data() {
			return {
				orderDetail: {
					fields: [
						{
						    key: "index",
						    label: "序号"
						},
						{
                            key: "productCode",
                            label: "品种编号"
                        },
                        {
                            label: "品种名称",
                            key: "productName"
                        },
                        {
                            label: "单位",
                            key: "unitName"
                        },
                        {
                            label: '数量',
                            key: 'orderQuantity'
                        },
                        {
                            label: '单价',
                            key: 'preSalePlanPrice'
                        },
                        {
                            label: '金额',
                            key: 'totalMoney'
                        }
					],
					items: [],
					isTableBusy: false
				},
                depositBillMainVO:{}

			};
		},
		mounted() {
			if (!this.checkMemberLogin()) {
				this.$router.push({
					name: "MemberLogin"
				});
				return;
			}
			this.getOrderDetailInfo();
		},
		methods: {
			formatDateTimeString,
			numberToFixed,
			getOrderDetailInfo() {
				this.orderDetail.isTableBusy = true;
				api.webPreSaleGetOrderDetail({
					depositBillRecordUuid: this.$route.query.depositBillRecordUuid
				}).then(res => {
					this.orderDetail.isTableBusy = false;
					if (res.code === 0) {
					    if (res.data.depositBillMainVOList != null) {
                            this.depositBillMainVO = res.data.depositBillMainVOList[0];
							let orderItemList = res.data.depositBillMainVOList[0].orderItmeList;
							if (orderItemList) {
								orderItemList.forEach(item => {
									if (item.productCode === '定金收取(%)') {
										item.productCode = '';
										item.productName = '';
									}
								});
							}
					        this.orderDetail.items = orderItemList;
					    }
					}
				});
			}
		}
	};
</script>

<style>
	.date-before{
		margin-top: 20px;
		font-weight: bold;
		color: #ec4040;
	}
	.orderKey {
		text-align: right;
		font-size: 14px;
		font-weight: bold;
	}

	.orderValue {
		font-size: 14px;
	}


	/* 信息 */
	.info-wrap {
		width: 100%;
		border: 1px solid #efefef;
		margin: 20px auto;
		background-color: #fafafa;
		padding: 15px 0px;
	}

	.info-wrap .order-info td {
		padding: 5px 30px;
	}

	.info-wrap .order-info td:nth-child(even) {
		color: #a16e02;
	}



	/* 表格 */
	.dataTable {
		margin-top: 20px;
	}

	.dataTable th {
		background-color: #efefef;
		height: 32px;
		line-height: 32px;
	}

	.table.b-table.b-table-caption-top>caption {
		color: #333;
	}

	.table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #dbdbdb;
        font-size: 14px;
	}

	.table-bordered td,
	.table-bordered th {
		border: 1px solid #dbdbdb;
	}

	.table-sm td,
	.table-sm th {
		padding: 10px 5px;
	}

	/* 页码 */
	.page-link {
		color: #757575 !important;
	}

	.page-link:hover {
		color: #00b151 !important;
	}

	.page-item.active .page-link {
		color: #fff !important;
		background-color: #28a745 !important;
		border-color: #28a745 !important;
	}

	.pagination-sm .page-link {
		padding: 5px 12px !important;
		margin-top: 40px;
	}

	.page-link:focus {
		box-shadow: none !important;
	}
    .dataTable td{
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/view/member/booking-order-detail.vue